const ROOT = 'invoiceIssues'

export const invoiceIssuesKeys = {
  all: [ROOT] as const,
}
